<template>
  <div class="banner">
    <div class="swiper">
      <swiper class="swiper" :options="swiperOptionh">
        <swiper-slide>
          <img style="width: 100%;height:800px;" src="https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner1_1.png">
        </swiper-slide>
        <swiper-slide>
          <img style="width: 100%;height: 800px;" src="https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner2.jpg">
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-h" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
  //导入swiper
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  export default {
    name: 'default',
    data() {
      return {
        swiperOptionh: {
          spaceBetween: 0,
          pagination: {
            el: '.swiper-pagination-h',
            clickable: true
          },
          loop: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        },
      };
    },
    components: {
      swiper,
      swiperSlide
    },
  };
</script>

<style lang="less">
.swiper-pagination-bullet{
    width: 16px;
    height: 8px;
    display: inline-block;
    border-radius: 4px;
    background: #FFFFFF;
    opacity: 0.2;
}
.swiper-pagination-bullet-active{
    opacity: 1;
    background: #FFFFFF;
    width: 48px;
}
    
</style>

<style lang="less" scoped>
  .banner {
    .swiper {
      width: 100%;

      /deep/.swiper-container {
        width: 100%;

        .swiper-slide {
          width: 100%;
          height: 800px;
          // padding-bottom: 28.1%;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
        }

        .swiper-pagination {
          .swiper-pagination-bullet-active {
            background-color: #FFFFFF;
            width:48px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue